import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { NOT_FOUND_ICON } from "../utils/svgs_new";
import { withDefault } from "../utils/withDefault";
import EmptyScaffoldBody from "./EmptyScaffoldBody/EmptyScaffoldBody";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface Props {
  title?: string;
  content?: string;
  onClickGoBack: () => void;
}

const NotFoundScaffold = (props: Props) => {
  const definedTitle = withDefault(props.title, translate(STRINGS.NOT_FOUND));
  const definedContent = withDefault(
    props.content,
    translate(STRINGS.THERE_SEEMS_TO_BE_NOTHING_HERE)
  );

  return (
    <Scaffold title={<ScaffoldTitle label={definedTitle} />} onClickGoBack={props.onClickGoBack}>
      <EmptyScaffoldBody
        icon={NOT_FOUND_ICON}
        label={definedContent}
        linkText={translate(STRINGS.GO_BACK)}
        onClickLink={props.onClickGoBack}
      />
    </Scaffold>
  );
};

export default React.memo(NotFoundScaffold);
